module.exports = __webpack_public_path__ + "media/images/gray_jean-014da288ec68ef6dea720b875efda5f5.png";